import React, { ReactElement, useState } from 'react';
import MuiTooltip, {
  TooltipProps,
  tooltipClasses
} from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';
import { IconButton } from '@mui/material';
import { useIsMobile } from '../../../utils/hooks/use-is-mobile';
import { Modal } from '../Modal';
import Button from '../Button';
import { ButtonTypes } from '../Button/button-types';

type TooltipComponentProps = {
  readonly children: ReactElement;
  readonly title: string;
};

const LightTooltip = styled(({ className, ...props }: TooltipProps) => (
  <MuiTooltip {...props} arrow={true} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.white,
    color: '#707070',
    boxShadow: '0px 0px 2px 0px rgba(0, 0, 0, 0.25)',
    fontSize: 12,
    fontWeight: 400,
    fontFamily: 'Poppins',
    maxWidth: 224,
    padding: 12,
    borderRadius: 8
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.common.white
  }
}));

function Tooltip({ children, title }: TooltipComponentProps): JSX.Element {
  const isMobile = useIsMobile();
  const [showModal, setShowModal] = useState(false);

  if (isMobile) {
    return (
      <>
        <IconButton
          data-testid='tooltip-mobile-trigger'
          onClick={() => setShowModal(true)}
          style={{
            cursor: 'pointer',
            display: 'inline-flex',
            background: 'none',
            border: 'none',
            padding: 0,
            outline: 'none',
            opacity: 1,
            color: 'var(--secondary-color)'
          }}
        >
          {children}
        </IconButton>
        <Modal.Root
          show={showModal}
          onHide={() => setShowModal(false)}
          data-testid='tooltip-mobile-modal'
        >
          <Modal.Header closeButton onHide={() => setShowModal(false)}>
            <></>
          </Modal.Header>
          <Modal.Body>
            <p style={{ textAlign: 'center' }}>{title}</p>
          </Modal.Body>
          <Modal.Footer>
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flex: 1
              }}
            >
              <Button
                data-testid='tooltip-mobile-close'
                onClick={() => setShowModal(false)}
                buttonType={ButtonTypes.Primary}
              >
                Entendi
              </Button>
            </div>
          </Modal.Footer>
        </Modal.Root>
      </>
    );
  }

  return (
    <LightTooltip title={title} placement='right-end'>
      {children}
    </LightTooltip>
  );
}

export default Tooltip;
